import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LoadingProvider } from './contexts/LoadingContext';
import { HelpProvider } from './contexts/HelpContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import GlobalLoader from './components/GlobalLoader';
import LoadingConnector from './components/LoadingConnector';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import UserManagement from './pages/UserManagement';
import Bridges from './pages/Bridges';
import CorrosionDamageManagement from './pages/CorrosionDamageManagement';
import DecayTriggerConfigManagement from './pages/DecayTriggerConfigManagement';
import NewSimulationTriggersManagement from './pages/NewSimulationTriggersManagement';
import MaintenanceCycleLimitsManagement from './pages/MaintenanceCycleLimitsManagement';
import SurfacePrepMethodsManagement from './pages/SurfacePrepMethodsManagement';
import WashingCostsManagement from './pages/WashingCostsManagement';
import MaterialsMasterManagement from './pages/MaterialsMasterManagement';
import FieldApplicationLaborManagement from './pages/FieldApplicationLaborManagement';
import SystemSettingsManagement from './pages/SystemSettingsManagement';
import RepairRulesManagement from './pages/RepairRulesManagement';
import LaborByCoatManagement from './pages/LaborByCoatManagement';
import DamageSplitManagement from './pages/DamageSplitManagement';
import ScenarioManagement from './pages/ScenarioManagement';
import SpanSimulation from './pages/SpanSimulation';
import RepairPlanning from './pages/RepairPlanning';
import BridgeDetail from './pages/BridgeDetail';

// New Repair Projects (Span-based)
import RepairProjects from './pages/RepairProjects';
import CreateRepairProject from './pages/CreateRepairProject';
import RepairProjectDetails from './pages/RepairProjectDetails';
import RepairProjectExecution from './pages/RepairProjectExecution';

// Enhanced Simulation Results
import EnhancedSimulationResults from './pages/EnhancedSimulationResults';
// New Simulation Engine (scaffold — separate from existing process)
import NewSimulationEngine from './pages/NewSimulationEngine';
import Help from './pages/Help';

function App() {
  return (
    <AuthProvider>
      <LoadingProvider>
        <HelpProvider>
        <Router>
          <div className="App">
            <LoadingConnector />
            <GlobalLoader />
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              
              {/* Protected routes */}
              <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="profile" element={<Profile />} />
                <Route path="settings" element={<Settings />} />
                <Route path="users" element={<UserManagement />} />
                
                {/* Bridge Management Routes */}
                <Route path="bridges" element={<Bridges />} />
                <Route path="bridges/:id" element={<BridgeDetail />} />
                
                {/* Masters Management Routes */}
                {/* <Route path="masters/components" element={<ComponentsManagement />} /> */}
                {/* <Route path="masters/component-types" element={<ComponentTypesManagement />} /> */}
                
                {/* New Master Data Routes */}
                  {/* Unified Corrosion & Damage Management */}
                  <Route path="masters/corrosion-damage" element={<CorrosionDamageManagement />} />
                  {/* Redirect old routes to unified page for backward compatibility */}
                  <Route path="masters/corrosion-categories" element={<Navigate to="/masters/corrosion-damage" replace />} />
                  <Route path="masters/damage-severity" element={<Navigate to="/masters/corrosion-damage" replace />} />
                  <Route path="masters/corrosion-damage-combinations" element={<Navigate to="/masters/corrosion-damage" replace />} />
                  
                  <Route path="masters/surface-prep-methods" element={<SurfacePrepMethodsManagement />} />
                  <Route path="masters/washing-costs" element={<WashingCostsManagement />} />
                  <Route path="masters/materials-master" element={<MaterialsMasterManagement />} />
                  <Route path="masters/field-application-labor" element={<FieldApplicationLaborManagement />} />
                  <Route path="masters/system-settings" element={<SystemSettingsManagement />} />
                  <Route path="masters/repair-rules" element={<RepairRulesManagement />} />
                  <Route path="masters/labor-by-coat" element={<LaborByCoatManagement />} />
                  <Route path="masters/damage-split-defaults" element={<Navigate to="/masters/corrosion-damage?tab=damage-split" replace />} />
                  <Route path="masters/decay-trigger-config" element={<DecayTriggerConfigManagement />} />
                  <Route path="masters/new-simulation-triggers" element={<NewSimulationTriggersManagement />} />
                  <Route path="masters/maintenance-cycle-limits" element={<MaintenanceCycleLimitsManagement />} />
                  
                  {/* Simulation Routes */}
                  <Route path="scenarios" element={<ScenarioManagement />} />
                  <Route path="span-simulation" element={<SpanSimulation />} />
                  <Route path="enhanced-simulation-results" element={<EnhancedSimulationResults />} />
                  <Route path="new-simulation-engine" element={<NewSimulationEngine />} />
                  
                  {/* Repair Planning Routes (OLD - component-based, deprecated) */}
                  <Route path="repair-planning" element={<RepairPlanning />} />
                  
                  {/* Repair Projects Routes (NEW - span-based) */}
                  <Route path="repair-projects" element={<RepairProjects />} />
                  <Route path="repair-projects/create" element={<CreateRepairProject />} />
                  <Route path="repair-projects/:id" element={<RepairProjectDetails />} />
                  <Route path="repair-projects/:id/execute" element={<RepairProjectExecution />} />

                  <Route path="help" element={<Help />} />
              </Route>
            </Routes>
          </div>
        </Router>
        </HelpProvider>
      </LoadingProvider>
    </AuthProvider>
  );
}

export default App;
